import script from "./AssessmentView.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentView.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentView.vue?vue&type=style&index=0&id=5e662896&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e662896"]])

export default __exports__